import React, { useEffect, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Header from './../../compoments/Header';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import api from './../../services/axios'
import AlertDialog from './../../compoments/AlertDialog'
import ImageUpload from './../../compoments/ImageUpload'
import Typography from '@material-ui/core/Typography';
import { Breadcrumbs } from '@material-ui/core';
import { Link } from 'react-router-dom'
import { Redirect } from 'react-router'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    height: '100vh',
    overflow: 'auto',
  },
  appBarSpacer: theme.mixins.toolbar,
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  disabled: {
    padding: 30,
    backgroundColor: 'red'
  }
}));

export default function DevicesUpdate({ match, history }) {

  const rota = 'devices';
  const roleName = 'Device';

  const [redirect, setRedirect] = React.useState(false);
  const [id, setId] = React.useState('');
  const [installationId, setInstallationId] = React.useState('');
  const [platform, setPlatform] = React.useState('');
  const [version, setVersion] = React.useState('');
  const [notification, setNotification] = React.useState('');
  const [tokenNotification, setTokenNotification] = React.useState('');
  const [createdAt, setCreatedAt] = React.useState('');
  const [updatedAt, setUpdatedAt] = React.useState('');

  const [name, setName] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [birthday, setBirthday] = React.useState('');
  const [stateAddress, setStateAddress] = React.useState('');
  const [city, setCity] = React.useState('');
  const [message, setMessage] = React.useState(false);
  const [alertTitle, setAlertTitle] = React.useState('');
  const [previewImage, setPreviewImage] = React.useState('');
  const [thumbnail, setThumbnail] = React.useState(null);  
  const [croppedAreaPixels, setCroppedAreaPixels] = React.useState(null);

  const preview = useMemo(() => {
    return thumbnail ? URL.createObjectURL(thumbnail) : null
  }, [thumbnail])


  const loadData = async () => {
    setId(match.params.id)
    const data = await api.get('/v1/devices/' + match.params.id)
    setInstallationId(data.data.installationId)
    setPlatform(data.data.platform)
    setVersion(data.data.version)
    setNotification(data.data.notification)
    setTokenNotification(data.data.tokenNotification)
    const createdAtCosnt = data.data.createdAt ?
      data.data.createdAt.split('-').reverse().join('/') : '';
    setCreatedAt(createdAtCosnt)
    const updatedAtCosnt = data.data.updatedAt ?
      data.data.updatedAt.split('-').reverse().join('/') : '';
    setUpdatedAt(updatedAtCosnt)
  }

  useEffect(() => {
    loadData()
  }, [])

  // const save = async () => {

  //   const data = new FormData();
  //   data.append('photo', thumbnail)
  //   data.append('name', name)
  //   data.append('email', email)
  //   data.append('birthday', birthday.split('/').reverse().join('-'))
  //   data.append('state', stateAddress)
  //   data.append('city', city)
  //   data.append('previewImage', previewImage)
  //   data.append('crop', JSON.stringify(croppedAreaPixels))
  //   data.append('_method', 'PUT')
  //   try {      
  //     const res = await api.post('/v1/devices/' + id, data, {
  //       headers: {
  //         Accept: 'application/json',
  //         'Content-Type': 'multipart/form-data',
  //       }
  //     })
  //     setAlertTitle('')
  //     history.push('/' + rota)
  //   } catch(error) {
  //     setAlertTitle('Erro')
  //     setMessage(error.response.data.errors[0].message || 'Erro')
  //   }

  // }

  const classes = useStyles();

  return (
    <div className={classes.root}>
      {redirect && <Redirect to={redirect} />}
      <CssBaseline />
      <Header titleHeader={'Editar Clientes'} />
      {/* CONTEUDO */}
      <main className={classes.content}>
        <div className={classes.appBarSpacer} />
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3}>
            {/* Recent Orders */}
            <Grid item xs={12}>
              <Breadcrumbs aria-label="breadcrumb">
                <Link color="inherit" to={`/${rota}`} >
                  {roleName}
                </Link>
                <Typography color="textPrimary">Cadastro</Typography>
              </Breadcrumbs>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.paper}>
                <form className={classes.form} noValidate>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <TextField
                        disabled={true}
                        variant="outlined"
                        fullWidth
                        id="installationId"
                        label="Id de instalação"
                        name="installationId"
                        autoComplete="installationId"
                        value={installationId}
                      />
                    </Grid>
                    <Grid item xs={6} >             
                      <TextField
                        disabled={true}
                        variant="outlined"
                        fullWidth
                        id="platform"
                        label="Plataforma"
                        name="platform"
                        autoComplete="platform"
                        value={platform}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        disabled={true}
                        variant="outlined"
                        fullWidth
                        name="version"
                        label="Versão"
                        type="text"
                        id="version"
                        value={version}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        disabled={true}
                        variant="outlined"
                        fullWidth
                        name="notification"
                        label="Recebe notificação"
                        type="text"
                        id="notification"
                        value={notification===1 ? 'Sim' : 'Não'}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        disabled={true}
                        variant="outlined"
                        fullWidth
                        name="tokenNotification"
                        label="Token para notificação"
                        type="text"
                        id="tokenNotification"
                        value={tokenNotification}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        disabled={true}
                        variant="outlined"
                        fullWidth
                        name="createdAt"
                        label="Criação"
                        type="text"
                        id="createdAt"
                        value={createdAt}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        disabled={true}
                        variant="outlined"
                        fullWidth
                        name="updatedAt"
                        label="Atualização"
                        type="text"
                        id="updatedAt"
                        value={updatedAt}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <Button
                        onClick={() => {
                          history.push('/' + rota)
                          // setRedirect(`/${rota}`)
                        }}
                        type="button"
                        variant="contained"
                        color="default"
                        style={{ marginRight: 30 }}
                      >
                        Voltar
                      </Button>
                      {/* <Button
                        type="button"
                        variant="contained"
                        color="primary"
                        onClick={save}
                      >
                        Salvar
                      </Button> */}
                    </Grid>
                  </Grid>
                </form>
              </Paper>
            </Grid>
          </Grid>
          <AlertDialog message={message}
            onClose={() => setMessage(false)}
            title={alertTitle}
            buttonSuccessText={'OK'}
          />
        </Container>
      </main>
    </div>
  );
}